import { MainInterfaceProps } from "@components/mainInterface/MainInterface";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useAccountingBreadcrumbs() {
    const location = useLocation();

    return useMemo(() => {
        const breadcrumbs: MainInterfaceProps["breadcrumbs"] = [
            {
                label: "Accounting",
                to: "/accounting",
            },
        ];

        switch (location.pathname) {
            case "/accounting/profit-loss":
                breadcrumbs.push({
                    label: "Profit & Loss",
                });
                break;
            case "/accounting/balance-sheet":
                breadcrumbs.push({
                    label: "Balance Sheet",
                });
                break;
            case "/accounting/general-ledger":
                breadcrumbs.push({
                    label: "General Ledger",
                });
                break;
            case "/accounting/chart-of-accounts":
                breadcrumbs.push({
                    label: "Chart of Accounts",
                });
                break;
            case "/accounting/trial-balance":
                breadcrumbs.push({
                    label: "Trial Balance",
                });
                break;
            default:
                delete breadcrumbs[0].to; // not interactable when there are no breadcrumbs
                break;
        }

        return breadcrumbs;
    }, [location.pathname]);
}
